import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';
import { Filters } from '../components/filters/filters';
import { Map } from '../components/map';
import { DirectoryHeader } from '../directory/directory-header';
import { DirectoryLocationsList } from '../directory/directory-locations-list';
import { LocationCardPopup } from '../location-card/location-card-popup';
import { useLocationsFilter } from '../locations-filter-provider';
import { useAvailableFilters } from '../utils/use-available-filters';

export function TabletLayout() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);
  const { detailCardEnabled } = settings;

  const { availableFilters } = useAvailableFilters();
  const { currentFiltersStyle } = useLocationsFilter();
  const showFilters =
    !!availableFilters.length && currentFiltersStyle === 'inline';

  return (
    <Container>
      <Sidebar>
        <DirectoryHeader />
        <DirectoryLocationsList
          detailedCard={settings.detailCardEnabled}
          bottomSpacerSize={0}
          previewWithActions={!detailCardEnabled}
        />
      </Sidebar>
      <MapContainer>
        <Map />
        <Show when={showFilters}>
          <Filters />
        </Show>
      </MapContainer>
      {detailCardEnabled && (
        <LocationCardPopup
          disablePointerEvents
          withBackdrop
          mobileMode
          closeOnOutsideClick
        />
      )}
      <FreeLink
        {...freeLinkSettings}
        appAlias={meta.appAlias}
        appName={meta.appName}
        style={{
          link: {
            position: 'absolute',
            zIndex: 99999999999,
            bottom: 0
          }
        }}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  flex-basis: 400px;
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3);
`;

const MapContainer = styled.div`
  position: relative;
  flex-grow: 1;
  z-index: 1;
`;
